import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiRequest } from '../../store/allApi'
import Cookies from 'js-cookie';

import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";

const Notification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isListOpen, setIsListOpen] = useState(false);
  const [userData, setUserData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  const backendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const backendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  const baseUrl = nodeMode === "development" ? backendLocalApiUrl : backendLiveApiUrl;

  const [input, setInput] = useState({
    sendTo: "",
    title: "",
    message: "",
    sendto_Id: [],
  });

  const userListData = () => {
      const access_token =  Cookies.get('token') || localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    const url = `User/all?page=0&_limit=100&_q=${input.sendto_Id}`;
    apiRequest(url, 'GET',null,headers)
      .then((res) => {
        setUserData(res.data?.admin || []);
      })
      .catch((e) => {
        console.error("Error fetching user data:", e);
      });
  };

  useEffect(() => {
    userListData();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "sendTo") {
      setIsListOpen(value === "selected");
    }
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setSelectedUsers(selectedValues);
    setInput((prev) => ({ ...prev, sendto_Id: selectedValues }));
  };

  const handleImageChange = (e) => {
    setSelectedImage(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    notify();
  };

  const notify = () => {
     const access_token =  Cookies.get('token') || localStorage.getItem("token")
      const headers = {
      Authorization: `Bearer ${access_token}`
    }
    setIsLoading(true);
    const url = `admin/send-notification`;

    const formData = new FormData();
    formData.append("title", input.title);
    formData.append("message", input.message);
    formData.append("sendto", input.sendTo);
    formData.append("sendto_Id", JSON.stringify(input.sendto_Id));
    if (selectedImage) {
      formData.append("image", selectedImage);
    }

    apiRequest(url, 'POST', formData, headers)
      .then(() => {
        setIsLoading(false);
        Swal.fire({ title: "Sent Successfully", icon: "success", confirmButtonText: "OK" });
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({ title: "Error Sending", icon: "error", confirmButtonText: "OK" });
        console.error("Notification Send Error:", error);
      });
  };

  const options = userData
    .filter((user) => user?.Name?.toLowerCase().includes(searchQuery.toLowerCase()))
    .map((user) => ({ value: user.id, label: user.Name }));

  return (
    <div className="container mt-5">
      <div className="card">
        <div className="card-body table_bg">
          <h5 className="dashboard_heading">Send Notification</h5>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group controlId="sendTo">
                  <Form.Label className="text-black">Send To</Form.Label>
                  <Form.Control as="select" name="sendTo" value={input.sendTo} onChange={handleChange}>
                    <option value="">Select an option</option>
                    <option value="all">ALL USERS</option>
                    <option value="verified">Verified</option>
                    <option value="active">Active</option>
                    <option value="selected">Selected User</option>
                  </Form.Control>
                </Form.Group>

                {isListOpen && (
                  <Form.Group controlId="selectedUsers">
                    <Form.Label className="text-black">Select Users</Form.Label>
                    <Select
                      isMulti
                      name="users"
                      options={options}
                      className="basic-multi-select text-dark"
                      classNamePrefix="select"
                      onChange={handleSelectChange}
                      value={options.filter((option) => selectedUsers.includes(option.value))}
                    />
                  </Form.Group>
                )}

                <Form.Group controlId="title">
                  <Form.Label className="text-black">Title</Form.Label>
                  <Form.Control type="text" name="title" value={input.title} onChange={handleChange} />
                </Form.Group>

                <Form.Group controlId="message">
                  <Form.Label className="text-black">Message</Form.Label>
                  <Form.Control as="textarea" name="message" value={input.message} onChange={handleChange} />
                </Form.Group>

                <Form.Group controlId="imageUpload">
                  <Form.Label className="text-black">Upload Image</Form.Label>
                  <Form.Control type="file" accept="image/*" onChange={handleImageChange} />
                </Form.Group>
              </Col>
            </Row>

            <div className="text-center">
              <Button variant="primary" type="submit" className="notificationbtn" >
                {isLoading ? (
                  <div>
                    <Spinner animation="grow" variant="success" />
                    <Spinner animation="grow" variant="danger" />
                    <Spinner animation="grow" variant="warning" />
                    <Spinner animation="grow" variant="info" />
                  </div>
                ) : (
                  "SEND"
                )}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Notification;
